/**
 *
 * AnnouncementDialog
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from "@material-ui/core/DialogContent";
import {DateField} from "../AdvancedForm/DateField";
import {TextField} from "../AdvancedForm/TextField";
import {EditorField} from "../AdvancedForm/EditorField";
import ImageField from "./ImageField/ImageFieldCreator";


const selectStyles = () => ({
    dialogTitle: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    content: {
        lineHeight: 'normal'
    }
});

class AnnouncementDialog extends React.PureComponent {

    handleSubmitButtonClick = () => {
        const {id, managers, onSubmit} = this.props;
        if (onSubmit) onSubmit(id, managers);
    };

    handleCloseButtonClick = () => {
        const {closeDialog, removeAnnouncement, announcement: {id}} = this.props
        closeDialog()
        removeAnnouncement(id)
    }

    render() {
        const {
            classes,
            open,
            announcement: {name, content, date, file},
        } = this.props;

        return (
            <div>
                <Dialog open={open}
                        fullWidth
                        maxWidth={'md'}>
                    <DialogTitle>
                        <div className={classes.dialogTitle}>
                            <span>Объявление</span>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <DateField
                            input={{value: date, name: 'date'}}
                            label="Дата"
                            meta={{touched: false}}
                            readOnly
                            fullWidth
                            formatmask="DD.MM.YYYY"
                        />
                        <TextField
                            input={{value: name, name: 'name'}}
                            label="Название"
                            meta={{touched: false}}
                            readOnly
                        />
                        <EditorField
                            input={{value: content, name: 'content'}}
                            label="Содержание"
                            meta={{touched: false}}
                            readOnly
                        />
                        <ImageField
                            file={file}
                            label="Файл"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseButtonClick} color="primary">
                            Закрыть
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    static propTypes = {
        announcement: PropTypes.object.isRequired,
        open: PropTypes.bool.isRequired,
        closeDialog: PropTypes.func,
    };
}

export default AnnouncementDialog = withStyles(selectStyles)(AnnouncementDialog);
